<template>
    <div class="container">
        <div class="top-banner">
            <swiper :options="bannerOption">
                <swiper-slide><img src="@/assets/store/bannerstore.png" alt=""></swiper-slide>
            </swiper>
            <!-- <div class="swiper-pagination"></div>
            <div class="swiper-icon swiper-right"></div>
            <div class="swiper-icon swiper-left"></div> -->
        </div>
        <div ref="mdxx" class="slide-container">
            <div class="block-title"><img src="@/assets/store/title_mission.png" style="
            width: 432px;height: auto;margin-bottom: 42px;margin-top: 30px;" alt=""></div>
            <div class="slide-imgs">
                <swiper :options="slideOptions">
                    <swiper-slide><img src="@/assets/store/3.png" alt=""></swiper-slide>
                    <swiper-slide><img src="@/assets/store/1.png" alt=""></swiper-slide>
                    <swiper-slide><img src="@/assets/store/2.png" alt=""></swiper-slide>
                    <swiper-slide><img src="@/assets/store/4.png" alt=""></swiper-slide>
                    <swiper-slide><img src="@/assets/store/5.png" alt=""></swiper-slide>
                </swiper>
                <div class="swiper-slide-icon swiper-slide-right"></div>
                <div class="swiper-slide-icon swiper-slide-left"></div>
            </div>
        </div>
        <!--门店实景-->
        <div ref="mdqj" class="vr-content">
            <div style="position: relative;">
                <iframe class="md-iframe" src="https://www.720yun.com/vr/febj5zeOsa9" frameborder="0" width="100%" height="900px"></iframe>
                <div :class="{'vr-mask':true,hideEl:!isLoading}">
                    <p class="vr-tip">拖动鼠标，观看720°全景图片</p>
                    <div class="vr-btn" @click="startOpt">开始浏览</div>
                </div>
            </div>
        </div>
       
   
        <!--门店查询-->
        <div ref="mdcx" class="search-content" style="text-align: center;">
            <div class="block-title"><img src="@/assets/store/openstore.png" style="width: 432px;margin-bottom: 20px;" alt=""></div>
            <!-- <div style="font-size: 76px;text-align: center; font-weight: 1500;">门店查询</div> -->
            <img src="@/assets/store/storecode.png" style="width: 450px;height: auto;margin-top: 20px;" alt="">
            <div style="font-size: 26px;text-align: center; font-weight: 1500;margin-top: 20px;">微信扫码查询</div>

        </div>
    </div>
</template>
<script>
    import BaiduMap from 'vue-baidu-map/components/map/Map.vue'
    import bmMarker from 'vue-baidu-map/components/overlays/Marker.vue'
    import bmLabel from 'vue-baidu-map/components/overlays/Label.vue'
    import bmGeolocation from 'vue-baidu-map/components/controls/Geolocation.vue'
    import bmCopyright from 'vue-baidu-map/components/controls/Copyright.vue'
    export default {
        components: {
            BaiduMap,
            bmMarker,
            bmLabel,
            bmGeolocation,
            bmCopyright
        },
        data(){
            return {
                bannerOption:{
                    effect: 'slide',
                    grabCursor: true,
                    centeredSlides: true,
                    slidesPerView: 'auto',
                    loop:false,
                    // autoplay:{
                    //     delay:3000,
                    //     disableOnInteraction: false,
                    // },
                    navigation: {
                        nextEl: '.swiper-left',
                        prevEl: '.swiper-right',
                    },
                    pagination: {
                        clickable:true,
                        el: '.swiper-pagination'
                    }
                },
                slideOptions:{
                    effect: 'slide',
                    loop:true,
                    slidesPerView: 3,
                    centeredSlides: true,
                    slidesOffsetBefore : 0,
                    navigation: {
                        nextEl: '.swiper-slide-left',
                        prevEl: '.swiper-slide-right',
                    }
                },
                isLoading:true,
                currentMark:'赵一鸣零食',
                center: {lng: 116.404, lat: 39.915},
                zoom: 14,
                queryWord:'',
                isRendered:false,
                currPage:1,
                storeList:[],
                isEnd:true,
                currShopId:'',
                isInit:true
            }
        },
        watch:{
            $route(to,from){
                if(to.query.block){
                    this.linkPos();
                }
            }
        },
        mounted(){
            this.linkPos();
            setTimeout(()=>{
                this.isLoading = false;
            },5000)
            // this.$nextTick(()=>{
            //     this.getMapData()
            //     this.$refs.queryListRef.addEventListener('scroll',this.watchScroll);
            // })
        },
        methods:{
            startOpt(){
                this.isLoading = false;
            },
            handler(){},
            queryMap(){
                this.currPage = 1;
                this.getMapData(false);
            },
            deleteSelect(){
                this.currentMark = '';
                this.currShopId = '';
                this.queryWord = '';
            },
            //切换地图中心点
            changeCenter(item){
                this.center.lng = item.longitude;
                this.center.lat = item.latitude;
                this.currentMark = item.name;
                this.currShopId = item.id;
            },
            //地图查询
            getMapData(isScroll){
                let name = this.isInit ? '宜春' : this.queryWord;
                const url = this.$WEBSITE_URL_OBJECT.map+'?current='+this.currPage+'&size=30&storeName='+name;
                !isScroll ? this.storeList = [] : '';
                this.$axios.get(url).then(res=>{
                    if(res.data.code === 0){
                        let list = res.data.data.records.filter(item=>{
                            return item.name && item.address;
                        })
                        res.data.data.records.length > 0 ? this.storeList.push(...list) : '';
                    }else{
                        this.center = {lng: 116.404, lat: 39.915};
                        // this.currentMark = '赵一鸣零食';
                        
                    }
                }).catch(err=>{
                    console.log(err)
                    this.currPage = this.currPage === 1 ? 1 : this.currPage-1;
                }).finally(()=>{
                    this.$nextTick(()=>{
                        this.isRendered = true;
                        this.isEnd = true;
                        if(!isScroll && this.storeList.length > 0){
                            this.center = {lng: this.storeList[0].longitude, lat: this.storeList[0].latitude};
                            this.currentMark = this.storeList[0].name;
                            this.currShopId = this.storeList[0].id;
                        }
                    })
                    this.isInit = false;
                })
            },
            watchScroll(e){
                const scrollTop=e.target.scrollTop//滚动条滚动时，距离顶部的距离
                const windowHeight=e.target.clientHeight //可视区域的高度
                const scrollHeight=e.target.scrollHeight//滚动条的总高度
                if(scrollHeight - (scrollTop+windowHeight) <= 20 && this.isEnd){
                    //滚动到底部时加载下一页
                    this.currPage++;
                    this.isEnd = false;
                    this.getMapData(true);
                }
            },
            linkPos(){
                const route = this.$route;
                const ref = route.query.block;
                if(ref){
                    const el = this.$refs[ref]
                    el.scrollIntoView(); 
                }
            }
        }
    }
</script>
<style scoped src="./index.css"></style>


// WEBPACK FOOTER //
// src/view/store/index.vue